import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"
import { CheckoutsEditStepUi } from "@src/widgets/onboarding/ui/tours/CryptoPayments/steps/CheckoutsEditStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class CheckoutsEditStep extends TourStepBase {
  component = CheckoutsEditStepUi
  name = `${ONBOARDING_TOURS.CRYPTO_PAYMENTS}_CheckoutsEdit`

  action() {
    return router.navigate({
      pathname: paths.checkouts,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Add the payment button to your website in just two clicks",
      title: "Accepting Cryptocurrency Payments",
    }
  }
}
